module.exports = __webpack_public_path__ + "img/voip-mute.460ba6a.png";